var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid"},[_c('h5',{attrs:{"col-6":""}},[_vm._v(_vm._s(_vm.surname)+" "+_vm._s(_vm.name)+" "+_vm._s(_vm.patronymic))])])}
var staticRenderFns = []

export { render, staticRenderFns }